import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { dashboardApi } from 'src/Services/API';

const useFetchDashboard = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-dashboard', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await dashboardApi.dashboardControllerGetDashboard(assetId)).data;
    },
    enabled: !!assetId,
    // The home page is an aggregate of tasks, events, projects, posts and finances: almost any
    // mutation anywhere in the app invalidates it. Rather than have all 127 mutation hooks
    // remember to invalidate this key, re-read it every time the page is mounted. `staleTime`
    // still shields it from refetching on mere re-renders.
    refetchOnMount: 'always',
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};

export default useFetchDashboard;
